// extracted by mini-css-extract-plugin
export default {"videoPreview":"JxxUv","active":"f0wMR","posterImage":"Dr9dH","playIcon":"n0X0k","cnImage":"MpSz6","container":"cHAux","video":"lx6Jb"};